import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchAssessmentResultsQueryVariables = SchemaTypes.Exact<{
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  filter?: SchemaTypes.InputMaybe<SchemaTypes.AssessmentResultFilterRule>;
}>;


export type FetchAssessmentResultsQuery = (
  { __typename: 'Query' }
  & { assessmentResults: (
    { __typename: 'PaginatedAssessmentResult' }
    & Pick<SchemaTypes.PaginatedAssessmentResult, 'count'>
    & { items: Array<(
      { __typename: 'AssessmentResult' }
      & AssessmentResultListItemDataFragment
    )> }
  ) }
);

export type FetchAssessmentResultQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchAssessmentResultQuery = (
  { __typename: 'Query' }
  & { assessmentResult: (
    { __typename: 'AssessmentResult' }
    & AssessmentResultListItemDataFragment
  ) }
);

export type AssessmentResultListItemDataFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedBy' | 'updatedAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'AitResult' } | (
    { __typename: 'CardioRespResult' }
    & AssessmentResultCardioRespResultDataFragment
  ) | { __typename: 'DigitSpanResult' } | { __typename: 'GrowthMindsetResult' } | (
    { __typename: 'InbodyCompositionResult' }
    & AssessmentResultInbodyCompositionResultDataFragment
  ) | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'NBackResult' } | { __typename: 'OrganisationalAiReadinessResult' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | (
    { __typename: 'StrengthResult' }
    & AssessmentResultStrengthResultDataFragment
  ) | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' }, updatedByUser?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )> }
);

export type AssessmentResultCardioRespResultDataFragment = (
  { __typename: 'CardioRespResult' }
  & Pick<SchemaTypes.CardioRespResult, 'vo2Max' | 'restingHR' | 'exerciseHR' | 'hrvMs'>
);

export type AssessmentResultStrengthResultDataFragment = (
  { __typename: 'StrengthResult' }
  & Pick<SchemaTypes.StrengthResult, 'squatRepMaxKg' | 'deadliftRepMaxKg' | 'maxPullUps' | 'sprintDragCarrySec'>
);

export type AssessmentResultInbodyCompositionResultDataFragment = (
  { __typename: 'InbodyCompositionResult' }
  & Pick<SchemaTypes.InbodyCompositionResult, 'weightKg' | 'bodyFatMassKg' | 'fatFreeMassKg' | 'skeletalMuscleMassKg' | 'totalBodyWater' | 'bodyFatPercentage' | 'ffmOfRightArmKg' | 'ffmOfRightArmPercentage' | 'ffmOfLeftArmKg' | 'ffmOfLeftArmPercentage' | 'ffmOfTrunkKg' | 'ffmOfTrunkPercentage' | 'ffmOfRightLegKg' | 'ffmOfRightLegPercentage' | 'ffmOfLeftLegKg' | 'ffmOfLeftLegPercentage'>
);

export type FetchAssessmentResultProgramsQueryVariables = SchemaTypes.Exact<{
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  filter?: SchemaTypes.InputMaybe<SchemaTypes.ProgramFilteringRule>;
}>;


export type FetchAssessmentResultProgramsQuery = (
  { __typename: 'Query' }
  & { programs: (
    { __typename: 'PaginatedProgram' }
    & Pick<SchemaTypes.PaginatedProgram, 'count'>
    & { items: Array<(
      { __typename: 'Program' }
      & AssessmentResultProgramItemDataFragment
    )> }
  ) }
);

export type AssessmentResultProgramItemDataFragment = (
  { __typename: 'Program' }
  & Pick<SchemaTypes.Program, 'id' | 'name' | 'description'>
  & { assessmentRuns: Array<(
    { __typename: 'AssessmentRun' }
    & AssessmentResultAssessmentRunDataFragment
  )>, courseInstance: (
    { __typename: 'CourseInstance' }
    & { executionSequence: Array<SchemaTypes.Maybe<(
      { __typename: 'ExecutionSequence' }
      & Pick<SchemaTypes.ExecutionSequence, 'moduleInstanceId' | 'order'>
      & { moduleInstance?: SchemaTypes.Maybe<(
        { __typename: 'ModuleInstance' }
        & AssessmentResultModuleInstanceDataFragment
      )> }
    )>> }
  ) }
);

export type AssessmentResultModuleInstanceDataFragment = (
  { __typename: 'ModuleInstance' }
  & Pick<SchemaTypes.ModuleInstance, 'id' | 'name' | 'description' | 'moduleDefinitionIdentifier'>
);

export type AssessmentResultAssessmentRunDataFragment = (
  { __typename: 'AssessmentRun' }
  & Pick<SchemaTypes.AssessmentRun, 'id' | 'name'>
  & { group: (
    { __typename: 'Group' }
    & AssessmentResultGroupFragment
  ) }
);

export type AssessmentResultGroupFragment = (
  { __typename: 'Group' }
  & Pick<SchemaTypes.Group, 'id' | 'name'>
  & { allMembers: Array<(
    { __typename: 'SuperAdminUser' }
    & AssessmentResultGroupMember_SuperAdminUser_Fragment
  ) | (
    { __typename: 'TenantUser' }
    & AssessmentResultGroupMember_TenantUser_Fragment
  )> }
);

export type AssessmentResultGroupMember_SuperAdminUser_Fragment = { __typename: 'SuperAdminUser' };

export type AssessmentResultGroupMember_TenantUser_Fragment = (
  { __typename: 'TenantUser' }
  & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
);

export type AssessmentResultGroupMemberFragment = AssessmentResultGroupMember_SuperAdminUser_Fragment | AssessmentResultGroupMember_TenantUser_Fragment;

export type DeleteAssessmentResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type DeleteAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { deleteAssessmentResult: (
    { __typename: 'DeleteAssessmentResultSuccessfulResponse' }
    & Pick<SchemaTypes.DeleteAssessmentResultSuccessfulResponse, 'success' | 'deletedId'>
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) }
);

export const AssessmentResultCardioRespResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultCardioRespResultData on CardioRespResult {
  vo2Max
  restingHR
  exerciseHR
  hrvMs
}
    `;
export const AssessmentResultStrengthResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultStrengthResultData on StrengthResult {
  squatRepMaxKg
  deadliftRepMaxKg
  maxPullUps
  sprintDragCarrySec
}
    `;
export const AssessmentResultInbodyCompositionResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultInbodyCompositionResultData on InbodyCompositionResult {
  weightKg
  bodyFatMassKg
  fatFreeMassKg
  skeletalMuscleMassKg
  totalBodyWater
  bodyFatPercentage
  ffmOfRightArmKg
  ffmOfRightArmPercentage
  ffmOfLeftArmKg
  ffmOfLeftArmPercentage
  ffmOfTrunkKg
  ffmOfTrunkPercentage
  ffmOfRightLegKg
  ffmOfRightLegPercentage
  ffmOfLeftLegKg
  ffmOfLeftLegPercentage
}
    `;
export const AssessmentResultListItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultListItemData on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on CardioRespResult {
      ...AssessmentResultCardioRespResultData
    }
    ... on StrengthResult {
      ...AssessmentResultStrengthResultData
    }
    ... on InbodyCompositionResult {
      ...AssessmentResultInbodyCompositionResultData
    }
  }
  createdAt
  completedAt
  updatedBy
  updatedByUser {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  updatedAt
}
    ${AssessmentResultCardioRespResultDataFragmentDoc}
${AssessmentResultStrengthResultDataFragmentDoc}
${AssessmentResultInbodyCompositionResultDataFragmentDoc}`;
export const AssessmentResultGroupMemberFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultGroupMember on User {
  ... on TenantUser {
    id
    name
    email
  }
}
    `;
export const AssessmentResultGroupFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultGroup on Group {
  id
  name
  allMembers {
    ...AssessmentResultGroupMember
  }
}
    ${AssessmentResultGroupMemberFragmentDoc}`;
export const AssessmentResultAssessmentRunDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultAssessmentRunData on AssessmentRun {
  id
  name
  group {
    ...AssessmentResultGroup
  }
}
    ${AssessmentResultGroupFragmentDoc}`;
export const AssessmentResultModuleInstanceDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultModuleInstanceData on ModuleInstance {
  id
  name
  description
  moduleDefinitionIdentifier
}
    `;
export const AssessmentResultProgramItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AssessmentResultProgramItemData on Program {
  id
  name
  description
  assessmentRuns {
    ...AssessmentResultAssessmentRunData
  }
  courseInstance {
    executionSequence {
      moduleInstanceId
      order
      moduleInstance {
        ...AssessmentResultModuleInstanceData
      }
    }
  }
}
    ${AssessmentResultAssessmentRunDataFragmentDoc}
${AssessmentResultModuleInstanceDataFragmentDoc}`;
export const FetchAssessmentResultsDocument = /*#__PURE__*/ gql`
    query FetchAssessmentResults($pagination: Pagination, $filter: AssessmentResultFilterRule) {
  assessmentResults(pagination: $pagination, filter: $filter) {
    count
    items {
      ...AssessmentResultListItemData
    }
  }
}
    ${AssessmentResultListItemDataFragmentDoc}`;

/**
 * __useFetchAssessmentResultsQuery__
 *
 * To run a query within a React component, call `useFetchAssessmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssessmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssessmentResultsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchAssessmentResultsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>(FetchAssessmentResultsDocument, options);
      }
export function useFetchAssessmentResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>(FetchAssessmentResultsDocument, options);
        }
// @ts-ignore
export function useFetchAssessmentResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>;
export function useFetchAssessmentResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAssessmentResultsQuery | undefined, FetchAssessmentResultsQueryVariables>;
export function useFetchAssessmentResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>(FetchAssessmentResultsDocument, options);
        }
export type FetchAssessmentResultsQueryHookResult = ReturnType<typeof useFetchAssessmentResultsQuery>;
export type FetchAssessmentResultsLazyQueryHookResult = ReturnType<typeof useFetchAssessmentResultsLazyQuery>;
export type FetchAssessmentResultsSuspenseQueryHookResult = ReturnType<typeof useFetchAssessmentResultsSuspenseQuery>;
export type FetchAssessmentResultsQueryResult = Apollo.QueryResult<FetchAssessmentResultsQuery, FetchAssessmentResultsQueryVariables>;
export const FetchAssessmentResultDocument = /*#__PURE__*/ gql`
    query FetchAssessmentResult($id: ObjectID!) {
  assessmentResult(id: $id) {
    ...AssessmentResultListItemData
  }
}
    ${AssessmentResultListItemDataFragmentDoc}`;

/**
 * __useFetchAssessmentResultQuery__
 *
 * To run a query within a React component, call `useFetchAssessmentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssessmentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssessmentResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchAssessmentResultQuery(baseOptions: Apollo.QueryHookOptions<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables> & ({ variables: FetchAssessmentResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>(FetchAssessmentResultDocument, options);
      }
export function useFetchAssessmentResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>(FetchAssessmentResultDocument, options);
        }
// @ts-ignore
export function useFetchAssessmentResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>;
export function useFetchAssessmentResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAssessmentResultQuery | undefined, FetchAssessmentResultQueryVariables>;
export function useFetchAssessmentResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>(FetchAssessmentResultDocument, options);
        }
export type FetchAssessmentResultQueryHookResult = ReturnType<typeof useFetchAssessmentResultQuery>;
export type FetchAssessmentResultLazyQueryHookResult = ReturnType<typeof useFetchAssessmentResultLazyQuery>;
export type FetchAssessmentResultSuspenseQueryHookResult = ReturnType<typeof useFetchAssessmentResultSuspenseQuery>;
export type FetchAssessmentResultQueryResult = Apollo.QueryResult<FetchAssessmentResultQuery, FetchAssessmentResultQueryVariables>;
export const FetchAssessmentResultProgramsDocument = /*#__PURE__*/ gql`
    query FetchAssessmentResultPrograms($companyId: ObjectID!, $filter: ProgramFilteringRule) {
  programs(companyId: $companyId, filter: $filter) {
    count
    items {
      ...AssessmentResultProgramItemData
    }
  }
}
    ${AssessmentResultProgramItemDataFragmentDoc}`;

/**
 * __useFetchAssessmentResultProgramsQuery__
 *
 * To run a query within a React component, call `useFetchAssessmentResultProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAssessmentResultProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAssessmentResultProgramsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchAssessmentResultProgramsQuery(baseOptions: Apollo.QueryHookOptions<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables> & ({ variables: FetchAssessmentResultProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>(FetchAssessmentResultProgramsDocument, options);
      }
export function useFetchAssessmentResultProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>(FetchAssessmentResultProgramsDocument, options);
        }
// @ts-ignore
export function useFetchAssessmentResultProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>;
export function useFetchAssessmentResultProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchAssessmentResultProgramsQuery | undefined, FetchAssessmentResultProgramsQueryVariables>;
export function useFetchAssessmentResultProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>(FetchAssessmentResultProgramsDocument, options);
        }
export type FetchAssessmentResultProgramsQueryHookResult = ReturnType<typeof useFetchAssessmentResultProgramsQuery>;
export type FetchAssessmentResultProgramsLazyQueryHookResult = ReturnType<typeof useFetchAssessmentResultProgramsLazyQuery>;
export type FetchAssessmentResultProgramsSuspenseQueryHookResult = ReturnType<typeof useFetchAssessmentResultProgramsSuspenseQuery>;
export type FetchAssessmentResultProgramsQueryResult = Apollo.QueryResult<FetchAssessmentResultProgramsQuery, FetchAssessmentResultProgramsQueryVariables>;
export const DeleteAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation DeleteAssessmentResult($id: ObjectID!, $companyId: ObjectID!) {
  deleteAssessmentResult(id: $id, companyId: $companyId) {
    __typename
    ... on DeleteAssessmentResultSuccessfulResponse {
      success
      deletedId
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    `;
export type DeleteAssessmentResultMutationFn = Apollo.MutationFunction<DeleteAssessmentResultMutation, DeleteAssessmentResultMutationVariables>;

/**
 * __useDeleteAssessmentResultMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentResultMutation, { data, loading, error }] = useDeleteAssessmentResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeleteAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssessmentResultMutation, DeleteAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssessmentResultMutation, DeleteAssessmentResultMutationVariables>(DeleteAssessmentResultDocument, options);
      }
export type DeleteAssessmentResultMutationHookResult = ReturnType<typeof useDeleteAssessmentResultMutation>;
export type DeleteAssessmentResultMutationResult = Apollo.MutationResult<DeleteAssessmentResultMutation>;
export type DeleteAssessmentResultMutationOptions = Apollo.BaseMutationOptions<DeleteAssessmentResultMutation, DeleteAssessmentResultMutationVariables>;